import { render, staticRenderFns } from "./attend_class_list2.vue?vue&type=template&id=d0481964&scoped=true"
import script from "./attend_class_list2.vue?vue&type=script&lang=js"
export * from "./attend_class_list2.vue?vue&type=script&lang=js"
import style0 from "./attend_class_list2.vue?vue&type=style&index=0&id=d0481964&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0481964",
  null
  
)

export default component.exports